import { z } from 'zod';
import { ErrorTypes } from '../../../utils/constants.js';
import { baseStructureSchema } from './base.structure.js';
import { blockSchema } from './block.js';
import { MediaType } from './media.js';

const hotspotOptions = blockSchema.extend({
  _id: z.string(),
  geometry: z.object({
    shape: z.enum(["circle", "rectangle", "polygon"]),
    height: z.number().optional(),
    width: z.number().optional(),
    points: z.array(
      z.object({
        x: z.number(),
        y: z.number()
      })
    )
  })
});
const hotspotStructureSchema = baseStructureSchema.extend({
  query: blockSchema.refine((query) => {
    const hasMedia = query.media?.filter((m) => m.type !== MediaType.IMAGE).length > 0;
    if (hasMedia) {
      return true;
    }
    if (!query.text) {
      return false;
    }
    const regex = /<[^>]+>/g;
    const cleanedText = query.text.replace(regex, "").trim();
    const hasLatex = query.text.includes("<katex");
    return cleanedText.length > 0 || hasLatex;
  }, {
    message: ErrorTypes.EMPTY_QUERY
  }).refine((query) => query.media.find((m) => m.type === MediaType.IMAGE), {
    message: ErrorTypes.QUERY_IMAGE
  }),
  answer: z.array(z.string()).min(1, {
    message: ErrorTypes.INVALID_ANSWER
  }).max(10, {
    message: ErrorTypes.INVALID_ANSWER
  }),
  marks: z.object({
    correct: z.number().min(1).max(20)
  }).optional(),
  options: z.array(hotspotOptions).min(2, {
    message: ErrorTypes.MIN_OPTIONS
  }).max(10, {
    message: ErrorTypes.MIN_OPTIONS
  })
});

export { hotspotOptions, hotspotStructureSchema };
